import React, { useState, useEffect, useCallback } from 'react';
import { Spinner, Alert, Badge } from 'reactstrap';
import { getTactic } from '../../services/api';

import PublicCanvas3D from './components/PublicCanvas3D';
import Timeline        from './components/Timeline';

import './Coach.css';

export default function TacticView({ match }) {
    const { userId, tacticId } = match.params;

    const [tactic,      setTactic]      = useState(null);
    const [loading,     setLoading]     = useState(true);
    const [notFound,    setNotFound]    = useState(false);
    const [currentTime, setCurrentTime] = useState(0);
    const [isPlaying,   setIsPlaying]   = useState(false);

    useEffect(() => {
        getTactic(userId, tacticId)
            .then(data => {
                if (!data) { setNotFound(true); return; }
                setTactic(data);
            })
            .catch(() => setNotFound(true))
            .finally(() => setLoading(false));
    }, [userId, tacticId]);

    const noop = useCallback(() => {}, []);

    if (loading) return (
        <div style={{ display: 'flex', justifyContent: 'center', padding: '3rem' }}>
            <Spinner />
        </div>
    );

    if (notFound) return (
        <div style={{ padding: '2rem' }}>
            <Alert color="warning">Táctica no encontrada.</Alert>
        </div>
    );

    const timelineProps = {
        currentTime,
        duration:         tactic.duration,
        isPlaying,
        editorMode:       'choreograph',
        tactic,
        selectedPlayerIndex: null,
        readOnly:         true,
        isFullscreen:     true,
        onTimeChange:     setCurrentTime,
        onPlay:           () => setIsPlaying(true),
        onPause:          () => setIsPlaying(false),
        onDurationChange: noop,
        onActionClick:    t => { setIsPlaying(false); setCurrentTime(t); },
    };

    return (
        <div className="coach-fullscreen-overlay">
            <div style={{
                padding: '0.5rem 1rem',
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem',
                background: 'rgba(10, 22, 40, 0.95)',
                borderBottom: '1px solid rgba(255,255,255,0.1)',
                flexShrink: 0,
            }}>
                <span style={{ color: '#fff', fontWeight: 600, fontSize: '1rem' }}>
                    {tactic.name || '(sin nombre)'}
                </span>
                <Badge color={tactic.type === 'offense' ? 'danger' : 'info'} pill style={{ fontSize: '0.7rem' }}>
                    {tactic.type === 'offense' ? 'Ataque' : 'Defensa'}
                </Badge>
            </div>
            <div className="field-canvas-container" style={{ flex: 1, minHeight: 0 }}>
                <PublicCanvas3D tactic={tactic} currentTime={currentTime} />
            </div>
            <div className="coach-timeline-panel" style={{ flexShrink: 0 }}>
                <Timeline {...timelineProps} />
            </div>
        </div>
    );
}
